export default __webpack_public_path__ + "static/media/july-pan.93d0eafe.jpg";